var _defs, _circle, _polygon, _polygon2, _polygon3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuAgriserviceOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.842mm",
    height: "5.842mm",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 47 47",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil1 {fill:#009846}\n    .fil0 {fill:#FEFEFE}\n    .fil2 {fill:#FEFEFE;fill-rule:nonzero}\n  "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 23,
    cy: 23,
    r: 23
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "12 27 35 27 35 10 12 10"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "7 35 39 35 35 28 12 28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "18 34 28 34 28 34 19 34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m23 15v-1h1v1h-1zm0 8v-7h1v7h-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAgriserviceOver);
export default __webpack_public_path__ + "static/media/menu-agriservice-over.06d416433798f82104e0db8acbaf6f89.svg";
export { ForwardRef as ReactComponent };